'use client';

import {active_posts as posts} from 'data/posts';
import Link from 'next/link';
import {format, formatDistanceToNow} from 'date-fns';
import PostSummary from 'components/Blog/PostSummary';
import {usePathname} from 'next/navigation';
import OperationsHeroSvg from 'animation/svg-anim/OperationsHeroSvg';
import BookBtn from 'components/buttons/BookBtn/BookBtn';
import Tags from 'components/Blog/PostTags';

const has_tag = tag => tag === 'all' ? p => true : p => (p?.tags ?? []).indexOf(tag) !== -1;
const do_negate = status => !status ? fn => (...args) => fn(...args) : fn => (...args) => !fn(...args);

const Blog = props => {
  const {tag = 'all', negate = false} = props;
  const filter = do_negate(negate)(has_tag(tag));
  const filtered_posts = posts.filter(filter);

  const [featured, ...other_posts] = filtered_posts;

  const path = usePathname();
  const [resource, instance] = path.split('/').filter(x => x !== '');  

  return (
    <div className='feed'>
      <div className='container'>
        <div>
          <h3 className='subtitle-overline'>Featured {resource === 'blog' ? (featured.tags.indexOf('news') !== -1 ? `news` : `post`) : resource} - {format(new Date(featured.published), 'MMM d, y')}</h3>
          <h2 className='featured-title'>{featured.title}</h2>
          <p>{featured.summary}</p>
          <div className='read-more-btn'>
            <BookBtn text='Read more' url={resource === 'feed' ? (featured.tags.indexOf('news') !== -1 ? `news/${featured.id}` : `blog/${featured.id}`) : `${resource}/${featured.id}/`} />
          </div>
        </div>
        <div className="design">
          <OperationsHeroSvg />
        </div>
      </div>
      <div className='grid'>
        {
          other_posts?.map(p => {
            const href = resource === 'feed' ? (p.tags.indexOf('news') !== -1 ? `/news/${p.id}` : `/blog/${p.id}`) : `/${resource}/${p.id}/`;
            return (
              <section key={p.id}>
                <div className='inner-container'>
                  <h5 className='subtitle'>{format(new Date(p.published), 'MMM d, y')}</h5>
                  <p className='title' onClick={() => {location.href=href}}>{p.title}</p>
                  <p className='summary' onClick={() => {location.href=href}}>{p?.summary}</p>
                  <div className='read-more'>
                    <div>
                      <Link href={href} legacyBehavior>
                        <a className='arrow-link'>
                          {'Read more'}
                        </a>
                      </Link>
                    </div>
                    <div className='post-tags'>
                      <Tags tags={p?.tags ?? []}/>
                    </div>
                  </div>
                </div>
              </section>
            );
          })
        }
      </div>
    </div>
  );
};

export default Blog;
